import { Component, OnInit, Input } from '@angular/core';
import { CommonNotificationService } from '../../services/common-notification.service';
import { BaseWidgetComponent } from '../base-widget.component';
import { CommonUtilityService, BrowserTypes } from '../../services/common-utility.service';

@Component({
    selector: 'sticky-snackbar',
    templateUrl: './sticky-snackbar.component.html',
    styleUrls: ['../widgets-custom-theme.scss', './sticky-snackbar.component.scss']
})
export class StickySnackbarComponent extends BaseWidgetComponent implements OnInit {
    footerText: string;
    previousText: string;
    textColor: string;
    previousColor: string;
    totalAmount: string;
    currencySymbol: string;
    hideCenterText: boolean;
    showTotalAmount: boolean = true;
    totalText: string;
    showEmailQuote: boolean;
    showMoveToRegisterFab: boolean = false;
    isIEBrowser: boolean = false;
    defaultLayout: string = "space-between center";

    @Input('totalAmountColor') totalAmountColor: string = "#cce015";

    constructor(private commonNotificationService: CommonNotificationService, private commonUtilityService: CommonUtilityService) {
        super();
    }

    ngOnInit() {
        this.footerText = "Please fill in the mandatory fields.";
        this.textColor = "white";
        this.totalAmount = "0.00";
        this.currencySymbol = "";
        this.hideCenterText = false;
        this.showTotalAmount = false;
        this.totalText = "Total";
        this.showEmailQuote = false;

        this.commonNotificationService.$stickyFooterTextSource.takeUntil(this.emitUnsubscribe).subscribe(
            (data: IStickySnackbarTextSource) => {
                this.previousText = this.footerText;
                this.previousColor = this.textColor;
                if (data.text != null && data.text != undefined) {
                    this.footerText = data.text;
                }
                if (data.color) {
                    this.textColor = data.color;
                }
                if (data.total) {
                    this.totalAmount = data.total;
                }
                if (data.currency != null && data.currency != undefined) {
                    this.currencySymbol = data.currency;
                }
                if (data.totalText != null && data.totalText != undefined) {
                    this.totalText = data.totalText;
                }
            });

        this.commonNotificationService.$setPreviousTextSource.takeUntil(this.emitUnsubscribe).subscribe(
            () => {
                this.footerText = this.previousText;
                this.textColor = this.previousColor;
            }
        );

        this.commonNotificationService.$hideCenterTextSource.takeUntil(this.emitUnsubscribe).subscribe(
            (flag: boolean) => {
                this.hideCenterText = flag;
            }
        );

        this.commonNotificationService.$showTotalAmountSource.takeUntil(this.emitUnsubscribe).subscribe(
            (flag: boolean) => {
                this.showTotalAmount = flag;
            }
        );

        this.commonNotificationService.$showEmailQuoteSource.takeUntil(this.emitUnsubscribe).subscribe(
            (flag: boolean) => {
                this.showEmailQuote = flag;
            }
        );

        this.commonNotificationService.$showMoveToRegisterSource.takeUntil(this.emitUnsubscribe).subscribe(
            (flag: boolean) => {
                this.showMoveToRegisterFab = flag;
            }
        );

        this.commonNotificationService.$emailQuoteLayout.takeUntil(this.emitUnsubscribe).subscribe(
            (desc: string) => {
                this.defaultLayout = desc;
            }
        );

        switch (this.commonUtilityService.getBrowserType()) {
            case BrowserTypes.IE:
                this.isIEBrowser = true;
        }
    }

    onClickEmailMe = () => {
        this.commonNotificationService.emitEmailMeClick();
    }
}

export interface IStickySnackbarTextSource {
    text: string;
    color: string;
    total: string;
    currency: string;
    totalText: string;
}



// WEBPACK FOOTER //
// ./src/app/widgets/sticky-snackbar/sticky-snackbar.component.ts